import { render, staticRenderFns } from "./write-off-popup.vue?vue&type=template&id=71a1c61e"
import script from "./write-off-popup.vue?vue&type=script&lang=js"
export * from "./write-off-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports